module.exports = __webpack_public_path__ + "img/Container.89b59cdf.png";